import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8" }
const _hoisted_2 = { class: "col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartsWidget3 = _resolveComponent("ChartsWidget3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.chart1.length>0)
        ? (_openBlock(), _createBlock(_component_ChartsWidget3, {
            key: 0,
            "widget-classes": "card-xl-stretch mb-xl-8 ",
            categories: _ctx.categories,
            totals: _ctx.totals
          }, null, 8, ["categories", "totals"]))
        : _createCommentVNode("", true)
    ])
  ]))
}